import { useTranslation } from 'react-i18next';

const TONES = [
    { value: 'lighthearted', labelKey: 'onboarding.stepTwo.tones.lighthearted', emoji: '☀️' },
    { value: 'serious', labelKey: 'onboarding.stepTwo.tones.serious', emoji: '🎭' },
    { value: 'dark', labelKey: 'onboarding.stepTwo.tones.dark', emoji: '🌑' },
    { value: 'whimsical', labelKey: 'onboarding.stepTwo.tones.whimsical', emoji: '✨' },
    { value: 'suspenseful', labelKey: 'onboarding.stepTwo.tones.suspenseful', emoji: '😰' },
    { value: 'romantic', labelKey: 'onboarding.stepTwo.tones.romantic', emoji: '💕' }
];

function StepTwo({ formData, updateFormData }) {
    const { t } = useTranslation();
    return (
        <div className="step-two">
            <h2 className="step-title">{t("onboarding.stepTwo.title")}</h2>
            <p className="step-subtitle">{t("onboarding.stepTwo.subtitle")}</p>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepTwo.setting")}</label>
                <textarea
                    className="input textarea"
                    placeholder={t("onboarding.stepTwo.settingPlaceholder")}
                    rows={3}
                    value={formData.setting}
                    onChange={(e) => updateFormData({ setting: e.target.value })}
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepTwo.mainCharacters")}</label>
                <textarea
                    className="input textarea"
                    placeholder={t("onboarding.stepTwo.characterPlaceholder")}
                    rows={3}
                    value={formData.characters}
                    onChange={(e) => updateFormData({ characters: e.target.value })}
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepTwo.toneMood")}</label>
                <div className="chip-group">
                    {TONES.map(tone => (
                        <button
                            key={tone.value}
                            type="button"
                            className={`chip ${formData.tone === tone.value ? 'selected' : ''}`}
                            onClick={() => updateFormData({ tone: tone.value })}
                        >
                            <span>{tone.emoji}</span>
                            {t(tone.labelKey)}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default StepTwo;
